import { Tab } from "@headlessui/react";
import { useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import PaymentsTable from "components/BookingsTable/PaymentsTable";
import config from "config.json";
import { useNavigate, useSearchParams } from "react-router-dom";
import useFetch from "hooks/useFetch";
import { set } from "lodash";



const CompleteBookingPayment = () => {

  const [booking, setBooking] = useState([]);
  const [allData, setAllData] = useState([]);
  const [bookingError, setBookingError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const bookingId = searchParams.get('booking');

  const { data, isLoading, error, fetchData } = useFetch(
    'GET',
    `${config.backend_url}/setia/reservas/get/${bookingId}`,
    {
      'Content-Type': 'application/json',
      'SetiaAuthorization': `${sessionStorage.getItem("user_token")}`
    }
  );
  const router = useNavigate();

  const renderBookingError = () => {

    return (
      <div className="flex justify-center items-center text-center">
        <div>
          <p className="text-red-500"> Lo sentimos ha ocurrido un error al obtener tu reserva.</p>
          <button onClick={() => router('/account-savelists')} className="mt-3 ml-4  bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-full ">Volver Mis Reservas</button>
        </div>
      </div>)
  };

  const renderBookingBalance = (booking: any) => {
    console.log (booking)
    if (!booking || !Array.isArray(booking.pagos)) {
      
      return (
        <div className="flex justify-center items-center text-center">
          <div>
            <p className="text-red-500">No hay información de pagos disponible.</p>
          </div>
        </div>
      );
    }
  
    let sumPagos = 0; 
    booking.pagos.forEach((pago: any) => {
      if (pago.estado_pago_enum === 'ACEPTADO') {
        sumPagos += Number(pago.monto);
      }
    });
  
    if (booking.monto_pactado - sumPagos > 0) {
      return (
        <div className="d-flex justify-center items-center text-center">
          <div>
            <p className="text-black pt-4">El monto total de tu reserva es de: <span className="font-semibold text-blue-600 font-semibold">{booking.monto_pactado.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span> </p>
          </div>
          <div>
            <p className="text-black pt-4">Tu reserva tiene un saldo pendiente de : <span className="font-semibold text-red-500 font-semibold">{(booking.monto_pactado - sumPagos).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span></p>
          </div>
          <div>
            <button className="mt-3 ml-4  bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-full ">Pagar {(booking.monto_pactado - sumPagos).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</button>
            <button className="mt-3 ml-4  bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-full "> Realizar pago parcial</button>
          </div>

        </div>
      );
    }
  
    return (
      <div className="flex justify-center items-center text-center">
        <div>
          <p className="text-green-500 pt-4">Ya pagaste el total de tu reserva</p>
        </div>
      </div>
    )
  };

  useEffect(() => {
    if (data) {

      const response = data as any

      setBooking(response.pagos);
      setAllData(response)
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setBookingError(true);
    }
  }, [error]);

  useEffect(() => {
    setBookingError(false);
    fetchData()
  }, [])

  return (
    <div className="bg-neutral-50 dark:bg-neutral-900">
      
      <div className="container pt-8 pb-10">

        <div className="space-y-6 space-x-2   sm:space-y-8 w-full h-full">
          <h2 className="text-2xl pt-10 lg:text-2xl font-semibold pl-2">Pagos de tu reserva</h2>
          <p> Desde acá podes ver el historial de pagos realizados a tu reserva y pagar el saldo restante.  
          </p>
          <p className="font-semibold"> Por favor recorda cancelar el saldo pendiente antes de la fecha de tu reserva para evitar inconvenientes.
          </p>
          <div className="d-flex justify-center text-center pb-72">
            {booking.length > 0 && <PaymentsTable payments={booking} />}
            {renderBookingBalance(allData)}
            {bookingError && renderBookingError()}
          </div>
        </div>
      </div>
    </div>






  );
};

export default CompleteBookingPayment;
